import { RegisterOptions } from "react-hook-form";
import { signinPasswordRegex } from "~/validator/signin_password";

export const PasswordField = ({
  label = "パスワード",
  register,
  errors,
}: {
  label?: string;
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
}) => {
  return (
    <div className="field">
      <label>
        <span className="label">{label}</span>
        <input
          type="password"
          placeholder="●●●●●●●●"
          name="password"
          data-test="input-password"
          {...register("password", {
            required: true,
            minLength: 8,
            pattern: signinPasswordRegex,
          })}
        />
      </label>
      {errors.password && (
        <span className="sub red">
          パスワードは8文字以上で、英字と数字が1文字以上含まれている必要があります。
          <br />
        </span>
      )}
      <span className="sub">8文字以上で、英語と数字を含む文字列</span>
    </div>
  );
};
